import {ILocationState,ILocationActionCreator,ILocationActionTypes} from 'models/ILocationState';

const initialState:ILocationState[] = []

const reducer = (state = initialState, { type, payload }: ILocationActionCreator) => {
    switch (type) {
      case ILocationActionTypes.FETCH_LOCATION_LIST_REQUEST:
        return {
          ...state,
          data:[],
        }
      case ILocationActionTypes.FETCH_LOCATION_LIST_SUCCESS:
        return {
          ...state,
          ...payload
        }
      default:
        return state;
    }
  };
  
  export default reducer;